import React from 'react'
import PropTypes from 'prop-types'

import generateID from 'functions/generateID'

class AddLink extends React.Component {
  state = {
    title: '',
    url: '',
  }

  _updateValue = (name, value) => {
    const change = {
      [name]: value,
    }

    this.setState(change)
  }

  _addLink = () => {
    const { title, url } = this.state
    const { createCallback } = this.props

    const link = {
      key: generateID(),
      title,
      url,
    }

    createCallback(link)
  }

  render(){
    const { title, url } = this.state
    const { render } = this.props

    return render({
      addLink: this._addLink,
      title,
      updateValue: this._updateValue,
      url,
    })
  }
}

AddLink.propTypes = {
  render: PropTypes.func,
  createCallback: PropTypes.func.isRequired,
}

export default AddLink
